import { render } from "./CaseStudiesPage.vue?vue&type=template&id=7d0ba155&scoped=true&ts=true"
import script from "./CaseStudiesPage.vue?vue&type=script&lang=ts"
export * from "./CaseStudiesPage.vue?vue&type=script&lang=ts"

import "./CaseStudiesPage.vue?vue&type=style&index=0&id=7d0ba155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0ba155"]])

export default __exports__